import React from 'react';
import "./Home.css";
import Calendar from "../Details/Calendar.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import WeekDay from "../Details/WeekDay.mjs";
import Meteo from "../Details/Meteo.mjs";
import Traffic from "../Details/Traffic.mjs";
import AutoIcon from "../../controls/AutoIcon.mjs";
import LanguageSwitcher from "../../controls/LanguageSwitcher/LanguageSwitcher.mjs";
import Annunci from "../Details/Annunci.mjs";
import {Glob as G} from "../../libs/Glob.mjs";
import LiveImage from "./LiveImage.mjs";

const Home = class Home extends React.Component {
	constructor(props) {
		super(props);
		this.state={
			lang: G.getLanguage(),
			langLong: G.getLanguageLong(),
			updated: G.getStatus('appPulse')
		};
		this.uid = G.generateUid('Home');
	}
	componentDidMount() {
		G.register("Prefs", l=>{
			if ( l?.language !== this.state.lang ) this.setState({
				lang: l?.language,
				langLong: G.getLanguageLong( l?.language ),
				updated: (new Date()).getTime()
			});
		}, this.uid);
		G.register("appPulse", p=>{
			this.setState({updated: p});
		}, this.uid);
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}
	render() {
		const d = new Date();
		return(
			<div className="Home" id={this.uid}>
				<div className={"annunciBox"}>
					<Annunci carousel={true} />
				</div>
				<div className={"weeklyBox"} key={ "weeklyBox"+this.state.updated }>
					<h2 className={"date"}>
						{d.toLocaleDateString(this.state.langLong, {weekday: 'long', month: 'long', day: 'numeric'})}
					</h2>
					<WeekDay/>
					{((new Date()).getHours() > 17) && (
						<>
							<h2 className={"mt-1 mb-1"}>
								<small><TextLabel value={"Tomorrow"}/>:</small>
							</h2>
							<WeekDay weekday={(d.getDay() + 1) % 7}/>
						</>
					)}
				</div>
				<div className={"calendarBox"}>
					<h2>
						<AutoIcon value={"calendar"}/>
						<TextLabel value={"Next dates"}/>:
					</h2>
					<Calendar max={7} />
				</div>
				<div className={"trafficBox"}>
					<Traffic/>
				</div>
				<div className={"meteoBox"}>
					<h2>
						<AutoIcon value={"meteo"}/>
						<TextLabel value={"Weather forecasts"}/>:
					</h2>
					<Meteo graph={true}/>
				</div>
				<LiveImage />
				<div className={"languageBox"}>
					<LanguageSwitcher notitle={true} />
				</div>
			</div>
		)
	}
}

export default Home;